export const NICEPAY_PENDING_KEY = "nicepay_pending";
export const NICEPAY_SUCCESS_KEY = "nicepay_success";

export type NicePayPendingKind = "feedback" | "lesson" | "test";

export type NicePayPending = {
  kind: NicePayPendingKind;
  orderId: string;
  amount: number;
  requestId?: string;
  bookingId?: string;
  reservedBookingId?: string;
  isProAssigned?: boolean;
  productName?: string;
  optionLabel?: string;
  fileName?: string;
};

export function encodeNicePayReserved(pending: NicePayPending): string {
  const assigned = pending.isProAssigned ? "1" : "0";
  if (pending.kind === "feedback") {
    return `fb|${pending.requestId || ""}|${assigned}`;
  }
  if (pending.kind === "lesson") {
    return `ls|${pending.bookingId || ""}`;
  }
  return "ts";
}

export function parseNicePayReserved(value: string | null | undefined): {
  kind: NicePayPendingKind;
  requestId?: string;
  bookingId?: string;
  isProAssigned?: boolean;
} {
  const raw = (value || "").trim();
  if (raw.startsWith("fb|")) {
    const [, requestId, assigned] = raw.split("|");
    return {
      kind: "feedback",
      requestId: requestId || undefined,
      isProAssigned: assigned === "1",
    };
  }
  if (raw.startsWith("ls|")) {
    const [, bookingId] = raw.split("|");
    return { kind: "lesson", bookingId: bookingId || undefined };
  }
  return { kind: "test" };
}

export function saveNicePayPending(pending: NicePayPending): void {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(NICEPAY_PENDING_KEY, JSON.stringify(pending));
}

export function readNicePayPending(): NicePayPending | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(NICEPAY_PENDING_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as NicePayPending;
  } catch {
    return null;
  }
}

export function clearNicePayPending(): void {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(NICEPAY_PENDING_KEY);
}
